import { db } from "../firebase";
import { doc, writeBatch } from "firebase/firestore";

/** Persists a manual ordering for a list of items in one collection — a
 * single batched write setting each doc's `sortOrder` to its 0-based
 * index. Shared by every "Manage X" admin page's drag-to-reorder grid
 * (courses, ferries, transport, accommodation, getaways) — same
 * mechanism, just a different collection name per caller. */
export async function saveItemOrder(collectionName, orderedIds) {
  const batch = writeBatch(db);
  orderedIds.forEach((id, index) => {
    batch.update(doc(db, collectionName, id), { sortOrder: index });
  });
  await batch.commit();
}

/** Sorts a fetched list by its `sortOrder` field (ascending), pushing
 * anything without one (new items created before this feature existed,
 * or created since and never dragged) to the end. Never done via a
 * Firestore `orderBy("sortOrder")` query — that would silently exclude
 * every doc missing the field instead of just sorting it last. Stable
 * (Array.prototype.sort is spec-guaranteed stable), so items without a
 * sortOrder keep whatever order the query already returned them in. */
export function sortByOrder(items) {
  return [...items].sort((a, b) => {
    const ao = a.sortOrder ?? Infinity;
    const bo = b.sortOrder ?? Infinity;
    return ao - bo;
  });
}
